import { render, staticRenderFns } from "./OrderSave.vue?vue&type=template&id=3cc1d250&scoped=true&"
import script from "./OrderSave.vue?vue&type=script&lang=js&"
export * from "./OrderSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc1d250",
  null
  
)

export default component.exports